(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tbrc-tabby-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tbrc-tabby-product')) {
  let sdkPromise;
  const getSdk = () => {
    if (window.TabbyPromo) return Promise.resolve();
    if (!sdkPromise) sdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.tabby.ai/tabby-promo.js';
      script.async = true;
      script.onload = resolve;
      script.onerror = () => { sdkPromise = null; reject(new Error('Tabby message unavailable')); };
      document.head.appendChild(script);
    });
    return sdkPromise;
  };
  customElements.define('tbrc-tabby-product', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.refresh = this.refresh.bind(this);
      this.observer = new MutationObserver(this.refresh);
      if (this.info) this.observer.observe(this.info, {childList:true,subtree:true,attributes:true,attributeFilter:['data-tbrc-variant-price','data-tbrc-currency']});
      this.refresh();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async refresh() {
      const marker = this.info?.querySelector('[data-tbrc-variant-price]');
      const cents = Number(marker?.dataset.tbrcVariantPrice || this.dataset.price);
      const currency = marker?.dataset.tbrcCurrency || this.dataset.currency;
      const signature = currency + ':' + cents;
      if (signature === this.lastSignature) return;
      this.lastSignature = signature;
      this.hidden = currency !== 'AED' || !Number.isFinite(cents) || cents <= 100000;
      if (this.hidden) { this.replaceChildren(); return; }
      try {
        await getSdk();
        if (!this.isConnected || this.lastSignature !== signature) return;
        const host = document.createElement('div');
        host.id = this.dataset.promoId;
        this.replaceChildren(host);
        new window.TabbyPromo({
          selector: '#' + host.id,
          currency: currency,
          price: (cents / 100).toFixed(2),
          lang: this.dataset.language === 'ar' ? 'ar' : 'en',
          source: 'product',
          publicKey: 'pk_019c90b4-956d-c542-ec51-1f483b5b3d5b',
          merchantCode: 'default',
          shouldInheritBg: false
        });
      } catch (error) { this.hidden = true; }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
